import React from "react"
import Icon from "../../Icon/Icon"
import Button from "../../Button/Button"
import {JWTProviders} from "../../../resources/orgSettings"
import {useModal} from "react-modal-hook"
import {JwksInfoModal} from "../JwksInfoModal/JwksInfoModal"
import * as Yup from "yup"
import TextField from "../TextField/TextField"

const jwksPathSchema = Yup.string()
	.required("JWKS path is required")
	.matches(/^https:\/\/([A-Za-z0-9\-\.]+)\.auth0\.com\/\.well-known\/jwks\.json$/, "Must be a valid Auth0 JWKS URL")

const jwtIssuerSchema = Yup.string().required("JWT Issuer is required")

export default function Auth0Fields() {
	const [showJwksInfoModal, hideJwksInfoModal] = useModal(() => (
		<JwksInfoModal close={hideJwksInfoModal} provider={JWTProviders.Auth0} />
	))

	return (
		<fieldset className="fields">
			<TextField
				name="jwksPath"
				label="JWKS Path"
				placeholder="https://your-domain.auth0.com/.well-known/jwks.json"
				validationSchema={jwksPathSchema}
				helpElements={
					<>
						<Icon
							icon="information-circle--interface-essential"
							size={12}
							data-tip="React-tooltip"
							data-for="jwks-path-tooltip"
						/>
						<Button type="button" className="jwks-button" onClick={showJwksInfoModal}>
							How to find my JWKS
						</Button>
					</>
				}
			/>
			<TextField
				name="jwtIssuer"
				label="JWT Issuer"
				placeholder="https://your-domain.auth0.com"
				validationSchema={jwtIssuerSchema}
			/>
		</fieldset>
	)
}
